/* Listen to events outside the webcomponent to close.
   Otherwise it gets closed when clicked or focussed on the
   buttons inside this component. */
const getElementTarget = (args) => {
    /* Check if the target is a child of wrapping webcomponent, because of the shadowDOM
       the highest element of the light DOM is the target (not working in Safari if not fullScreen) */
    const targetChild = args.target.shadowRoot;
    const isTargetChild = targetChild && targetChild.contains(args.element);
    return (args.active &&
        args.target != args.element &&
        !isTargetChild &&
        /* Find the first element in this component and all slots
           that matches the target, if not find anything return true */
        !Array.from(args.element.querySelectorAll('*')).find((el) => el == args.target));
};

export { getElementTarget as g };
